// partnerImages.jsx
import partner1 from "../../assets/img/partners/cocacola.jpeg";
import partner2 from "../../assets/img/partners/darling.png";
import partner3 from "../../assets/img/partners/delish.png";
import partner4 from "../../assets/img/partners/drmatress.png";
import partner5 from "../../assets/img/partners/eabl.jpeg";
import partner6 from "../../assets/img/partners/furnitureplace.png";
import partner7 from "../../assets/img/partners/lcwaikiki.png";
import partner8 from "../../assets/img/partners/megagrowth.png";
import partner9 from "../../assets/img/partners/orient.png";
import partner10 from "../../assets/img/partners/prestige.png";
import partner11 from "../../assets/img/partners/sarit.png";
import partner12 from "../../assets/img/partners/titi.png";
import partner13 from "../../assets/img/partners/tworivers.png";
import partner14 from "../../assets/img/partners/vspa.png";

const partners = [
  { name: "Coca Cola", img: partner1 },
  { name: "Darling", img: partner2 },
  { name: "Delish", img: partner3 },
  { name: "Dr. Mattress", img: partner4 },
  { name: "EABL", img: partner5 },
  { name: "Furniture Place", img: partner6 },
  { name: "LC Waikiki", img: partner7 },
  { name: "Mega Growth", img: partner8 },
  { name: "Orient", img: partner9 },
  { name: "Prestige", img: partner10 },
  { name: "Sarit", img: partner11 },
  { name: "Titi", img: partner12 },
  { name: "Two Rivers", img: partner13 },
  { name: "V Spa", img: partner14 },
];

export default partners;
